/**
 * banniere.js
 */

// Import
import "./banniere.scss";
import $ from 'jquery';

if($('.metaslider-flex').length > 0) {
    $('.home #banner-zone-full .slides li:first-child').each(function (e) {
        if ($(this).find("img").attr('title').indexOf("Russell") >= 0) {
            var prochaineImage = $(this).next();
            prochaineImage.insertBefore($(this));
        }
    });
}

$(function() {
    setCouleurTexteBanniere();

    $('.home #banner-zone-full aside > div').removeClass('d-lg-none');
});

function setCouleurTexteBanniere() {
    var nomImage = "";
    var windowWidth = document.body.clientWidth;
    
    if($('.metaslider-flex').length > 0) {
        if (windowWidth < 576 && $('body').not('.home')) {
            nomImage = $('.metaslider-flex.d-block.d-sm-none  .flexslider .slides li.flex-active-slide img').attr('title');
        } else if ($('body').not('.home') || (windowWidth > 991 && $('body').hasClass('home'))) {
            nomImage = $('.metaslider-flex.d-none .flexslider .slides li.flex-active-slide img').attr('title');
        } else {
            nomImage = $('.metaslider-flex .flexslider .slides li.flex-active-slide img').attr('title');
        }

        if(typeof nomImage !== "undefined") {
            if (nomImage.indexOf("orange") != -1 || nomImage.indexOf("rouge") != -1 || nomImage.indexOf("mauve") != -1 || nomImage.indexOf("vert") != -1) {
                $('.home .wrap-text-banniere h2, .home .wrap-text-banniere p, .wrap-text-banniere.text-banniere-etroite').css("color", "white");
            }
        }
        else {
            setTimeout(setCouleurTexteBanniere, 200);
        }
        
    }
}


